import { ShieldCheck, UserCog } from 'lucide-react';
import { OFFICER_ROLES, OBSERVER_ROLE, ROLE_LABELS, ROLE_DESCRIPTIONS, type Role } from '@duty/shared';
import { useRole } from '@/auth/role';

/**
 * Role indicator + standalone acting-role picker. When the app is signed in via
 * SWA auth the role is authoritative and shown read-only. In standalone/tabletop
 * mode the user chooses an acting role — clearly labelled, never a real sign-in.
 */
export function RoleSwitcher() {
  const { role, source, userName, setActingRole } = useRole();

  if (source === 'swa') {
    return (
      <span
        className="inline-flex items-center gap-1 text-xs text-muted"
        title={`${userName ?? ''} · ${ROLE_DESCRIPTIONS[role]}`}
      >
        <ShieldCheck size={14} className="text-ok" />
        {ROLE_LABELS[role]}
      </span>
    );
  }

  const roles: Role[] = [OBSERVER_ROLE, ...OFFICER_ROLES];
  return (
    <label
      className="inline-flex items-center gap-1 text-xs text-muted"
      title="Standalone mode — choose the role you are acting as"
    >
      <UserCog size={14} className="text-accent" />
      <span className="sr-only">Acting role</span>
      <select
        value={role}
        onChange={(e) => setActingRole(e.target.value as Role)}
        className="rounded-md border border-border bg-surface-2 px-1.5 py-0.5 text-xs text-text focus:border-accent/60"
        aria-label="Acting role (standalone)"
      >
        {roles.map((r) => (
          <option key={r} value={r}>
            {ROLE_LABELS[r]}
          </option>
        ))}
      </select>
    </label>
  );
}
